import React from "react"
import { useSetting } from "app/forms/data/form-data"
import { useStyles } from "app/forms/data/use-styles"
import { OldButton } from "@kit/design/old-button"
import cx from "classnames"

const isBackgroundLight = background => {
  let r, g, b, hsp, color

  if (background.match(/^rgb/)) {
    color = background.match(
      /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/
    )

    r = color[1]
    g = color[2]
    b = color[3]
  } else {
    color = +(
      "0x" + background.slice(1).replace(background.length < 5 && /./g, "$&$&")
    )

    r = color >> 16
    g = (color >> 8) & 255
    b = color & 255
  }

  hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b))

  if (hsp > 127.5) {
    return true
  } else {
    return false
  }
}

export const BuiltWithElement = ({ editing, onClick, ...props }) => {
  const styles = useStyles()
  const [setting] = useSetting("PoweredBy")
  const { variant } = props

  const background = styles.forElement(props.background).backgroundColor
  const image = styles.forElement(props.image).backgroundImage
  const imageOpacity = styles.forElement(props.image).opacity
  const opacityThreshold = 0.6
  let renderColor = "block"

  if (background) {
    if (image && imageOpacity) {
      const isWithinOpacityThreshold =
        Math.fround(parseFloat(imageOpacity)) < Math.fround(opacityThreshold)

      if (isWithinOpacityThreshold) {
        renderColor = isBackgroundLight(background) ? "dark" : "light"
      }
    } else {
      renderColor = isBackgroundLight(background) ? "dark" : "light"
    }
  }

  const renderVariant = variant ? variant : renderColor

  const handleClick = event => {
    event.preventDefault()
    onClick(event)
  }

  if (editing) {
    const className = cx("formkit-powered-by-convertkit-container", {
      "opacity-25": !setting.show
    })
    return (
      <div className={className}>
        <OldButton
          type="button"
          className="formkit-powered-by-convertkit outline-none focus:outline-none"
          data-element="powered-by"
          data-active={setting.show}
          data-variant={renderVariant}
          onClick={handleClick}
        >
          Built with Kit
        </OldButton>
      </div>
    )
  }

  if (setting.show) {
    return (
      <div className="formkit-powered-by-convertkit-container">
        <a
          href={setting.url}
          data-element="powered-by"
          className="formkit-powered-by-convertkit"
          data-variant={renderVariant}
          target="_blank"
          rel="nofollow noopener"
        >
          Built with Kit
        </a>
      </div>
    )
  }

  return null
}
